import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_PLEITOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    listarPleitos() {
        return axiosJwt
            .get(`${api}/pleitos/uai`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPleitoPorId(id) {
        return axiosJwt
            .get(`${api}/pleitos/uai/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluir(id) {
        return axiosJwt
            .delete(`${api}/pleitos/uai/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterGestores() {
        return axiosJwt
            .get(`${api}/pleitos/uai/gestores`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFornecedor(cnpjcpf) {
        return axiosJwt
            .get(`${api}/pleitos/uai/obterfornecedor/${cnpjcpf}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserir(pleito) {
        return axiosJwt
            .post(`${api}/pleitos/uai`, pleito)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovarPertinencia(pleitoId) {
        return axiosJwt
            .put(`${api}/pleitos/uai/aprovarpertinencia/${pleitoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    reprovarPertinencia(pleitoId, justificativa) {
        return axiosJwt
            .put(
                `${api}/pleitos/uai/reprovarpertinencia/${pleitoId}/${justificativa}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    alterar(pleito) {
        return axiosJwt
            .put(`${api}/pleitos/uai`, pleito)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDocumentosPleito(id) {
        return axiosJwt
            .get(`${api}/pleitos/uai/documentos/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirDocumentoPleito(id) {
        return axiosJwt
            .delete(`${api}/pleitos/uai/documentos/${id}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadDocumentoPleito(pleitoId, idDocumento) {
        return axiosJwt
            .get(
                `${api}/pleitos/uai/downloaddocumento/${pleitoId}/${idDocumento}`,
                { responseType: 'blob' }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDocumentoPleito(documento) {
        const formData = new FormData()
        formData.append('pleitoId', documento.pleitoId)
        formData.append('vcNomeArquivo', documento.vcNomeArquivo)
        formData.append('arquivo', documento.arquivo)
        formData.append('descricaoArquivo', documento.descricaoArquivo)
        return axiosJwt
            .post(`${api}/pleitos/uai/inserirdocumento`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterUnidades() {
        return axiosJwt
            .get(`${api}/pleitos/uai/unidades`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterNaturezas() {
        return axiosJwt
            .get(`${api}/pleitos/uai/naturezas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAcoes(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/uai/${pleitoId}/acoes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirAcao(acao) {
        return axiosJwt
            .post(`${api}/pleitos/uai/${acao.pleitoId}/acoes`, acao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAcao(pleitoId, acaoId) {
        return axiosJwt
            .delete(`${api}/pleitos/uai/${pleitoId}/acoes/${acaoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterMetasPorAcao(acaoId) {
        return axiosJwt
            .get(`${api}/pleitos/uai/acoes/${acaoId}/metas`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirMeta(meta) {
        return axiosJwt
            .post(`${api}/pleitos/uai/acoes/${meta.acaoId}/metas`, meta)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirMeta(metaId, acaoId) {
        return axiosJwt
            .delete(`${api}/pleitos/uai/acoes/${acaoId}/metas/${metaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposInstrumento() {
        return axiosJwt
            .get(`${api}/pleitos/uai/tiposinstrumento`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDespesasParceiro(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/uai/${pleitoId}/despesasparceiro`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDespesaParceiro(despesa) {
        return axiosJwt
            .post(
                `${api}/pleitos/uai/${despesa.pleitoId}/despesasparceiro`,
                despesa
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirDespesaParceiro(pleitoId, despesaParceiroId) {
        return axiosJwt
            .delete(
                `${api}/pleitos/uai/${pleitoId}/despesasparceiro/${despesaParceiroId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDespesasSebrae(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/uai/${pleitoId}/despesassebrae`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDespesaSebrae(despesa) {
        return axiosJwt
            .post(
                `${api}/pleitos/uai/${despesa.pleitoId}/despesassebrae`,
                despesa
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirDespesaSebrae(pleitoId, despesaSebraeId) {
        return axiosJwt
            .delete(
                `${api}/pleitos/uai/${pleitoId}/despesassebrae/${despesaSebraeId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCronogramasDesembolsoSebrae(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/uai/${pleitoId}/cronogramasdesembolsosebrae`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirCronogramaDesembolsoSebrae(cronogramaDesembolsoSebrae) {
        return axiosJwt
            .post(
                `${api}/pleitos/uai/${cronogramaDesembolsoSebrae.pleitoId}/cronogramasdesembolsosebrae`,
                cronogramaDesembolsoSebrae
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirDespesaSebrae(pleitoId, cronogramaDesembolsoSebraeId) {
        return axiosJwt
            .delete(
                `${api}/pleitos/uai/${pleitoId}/cronogramasdesembolsosebrae/${cronogramaDesembolsoSebraeId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCronogramasDesembolsoSebrae(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/uai/${pleitoId}/cronogramasdesembolsosebrae`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirCronogramaDesembolsoSebrae(cronogramaDesembolsoSebrae) {
        return axiosJwt
            .post(
                `${api}/pleitos/uai/${cronogramaDesembolsoSebrae.pleitoId}/cronogramasdesembolsosebrae`,
                cronogramaDesembolsoSebrae
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirCronogramaDesembolsoSebrae(pleitoId, cronogramaDesembolsoSebraeId) {
        return axiosJwt
            .delete(
                `${api}/pleitos/uai/${pleitoId}/cronogramasdesembolsosebrae/${cronogramaDesembolsoSebraeId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCronogramasDesembolsoParceiro(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/uai/${pleitoId}/cronogramasdesembolsoparceiro`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirCronogramaDesembolsoParceiro(cronogramaDesembolsoParceiro) {
        return axiosJwt
            .post(
                `${api}/pleitos/uai/${cronogramaDesembolsoParceiro.pleitoId}/cronogramasdesembolsoparceiro`,
                cronogramaDesembolsoParceiro
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirCronogramaDesembolsoParceiro(
        pleitoId,
        cronogramaDesembolsoParceiroId
    ) {
        return axiosJwt
            .delete(
                `${api}/pleitos/uai/${pleitoId}/cronogramasdesembolsoparceiro/${cronogramaDesembolsoParceiroId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovarConformidadeTecnica(pleitoId) {
        return axiosJwt
            .put(`${api}/pleitos/uai/aprovarconformidadetecnica/${pleitoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    reprovarConformidadeTecnica(pleitoId, justificativa) {
        return axiosJwt
            .put(
                `${api}/pleitos/uai/reprovarconformidadetecnica/${pleitoId}/${justificativa}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCronogramasFisicos(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/uai/${pleitoId}/cronogramasfisicos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirCronogramaFisico(cronogramaFisico) {
        return axiosJwt
            .post(
                `${api}/pleitos/uai/${cronogramaFisico.pleitoId}/cronogramasfisicos`,
                cronogramaFisico
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirCronogramaFisico(pleitoId, cronogramaFisicoId) {
        return axiosJwt
        .delete(`${api}/pleitos/uai/${pleitoId}/cronogramasfisicos/${cronogramaFisicoId}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorHandler(error)
        })
    },

    verificarAdimplenciaProponente(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/uai/${pleitoId}/verificaradimplencia`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterParecerFinanceiro(pleitoId){
        return axiosJwt
            .get(`${api}/pleitos/uai/${pleitoId}/parecerfinanceiro`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirParecerFinanceiro(parecerFinanceiro) {
        return axiosJwt
            .post(`${api}/pleitos/uai/${parecerFinanceiro.pleitoId}/parecerfinanceiro`, parecerFinanceiro)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    
    excluirParecerFinanceiro(pleitoId, parecerFinanceiroId) {
        return axiosJwt
        .delete(`${api}/pleitos/uai/${pleitoId}/parecerfinanceiro/${parecerFinanceiroId}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorHandler(error)
        })
    },

    emitirAtpDirex(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/uai/emitiratpdirex/${pleitoId}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    emitirDocumentacaoJuridica(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/uai/emitirdocumentacaojuridica/${pleitoId}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    emitirPrevisaoFinanceira(pleitoId) {
        return axiosJwt
            .get(`${api}/pleitos/uai/emitirprevisaofinanceira/${pleitoId}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovacaoGeralPleito(pleitoId) {
        return axiosJwt
            .put(`${api}/pleitos/uai/aprovarpleitogeral/${pleitoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    reprovacaoGeralPleito(pleitoId) {
        return axiosJwt
            .put(`${api}/pleitos/uai/reprovarpleitogeral/${pleitoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDocumentosConformidadeTecnica(pleitoId, conformidadeTecnicaId) {
        return axiosJwt
            .get(`${api}/pleitos/uai/${pleitoId}/conformidadetecnica/documentos/${conformidadeTecnicaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirDocumentoConformidadeTecnica(doc) {
        return axiosJwt
            .delete(`${api}/pleitos/uai/${doc.pleitoId}/conformidadetecnica/documentos/${doc.conformidadeTecnicaId}/${doc.idDocumento}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadDocumentoConformidadeTecnica(pleitoId, conformidadeTecnicaId, idDocumento) {
        return axiosJwt
            .get(`${api}/pleitos/uai/${pleitoId}/conformidadetecnica/documentos/${conformidadeTecnicaId}/downloaddocumento/${idDocumento}`, { responseType: 'blob' })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirDocumentoConformidadeTecnica(documento) {
        const formData = new FormData()
        formData.append('pleitoId', documento.pleitoId)
        formData.append('conformidadeTecnicaId', documento.conformidadeTecnicaId)
        formData.append('vcNomeArquivo', documento.vcNomeArquivo)
        formData.append('arquivo', documento.arquivo)
        formData.append('descricaoArquivo', documento.descricaoArquivo)
        return axiosJwt
            .post(`${api}/pleitos/uai/${documento.pleitoId}/conformidadetecnica/documentos`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }})
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
}
